import { FormControl, FormLabel, TextField } from '@mui/material';
import React, { useCallback } from 'react';

type Props = {
	label: string;
	setValue: (value: number | undefined) => void;
	value: string;
	placeholder?: string;
	min?: number;
	max?: number;
};

const NumberControl: React.FC<Props> = ({
	value,
	setValue,
	label,
	placeholder,
	min,
	max
}) => {
	const onChange = useCallback(
		(e: { target: { value: string } }) => {
			let intVal: number | undefined = parseInt(e.target.value, 10);
			if (
				Number.isNaN(intVal) ||
				(min && intVal < min) ||
				(max && intVal > max)
			)
				intVal = undefined;
			setValue(intVal);
		},
		[min, max, setValue]
	);

	return (
		<FormControl fullWidth margin="normal" component="fieldset">
			<FormLabel component="legend">{label}</FormLabel>
			<TextField
				inputProps={{ min, max }}
				type="number"
				defaultValue={value}
				onChange={onChange}
				placeholder={placeholder}
			/>
		</FormControl>
	);
};

NumberControl.defaultProps = {
	placeholder: undefined,
	min: undefined,
	max: undefined
};

const MemoNumberControl = React.memo(NumberControl);

export { MemoNumberControl as NumberControl };
